<template>
    <div>
        <slot name="target" ref="target"></slot>
        <div ref="source" style="position: absolute; z-index:999; padding-bottom: 6px" v-show="show">
            <slot></slot>
        </div>
    </div>
</template>

<script>

export default {
    props: {
        direction: String,
        mx: {
            type: Number,
            default: 0
        },
        my: {
            type: Number,
            default: 0
        },
        show: Boolean
    }
}
</script>